import 'babel-polyfill'
import Vue from 'vue'
//import './plugins/vuetify'
import App from './App.vue'
import router from './router/router'
import './registerServiceWorker'
//import VueApexCharts from 'vue-apexcharts'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import './config/enum'
import './plugins/axios'
import './plugins/VueProgressBar'
import vuetify from '@/plugins/vuetify'
import store from './store'

//var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin

Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')


